import { ContextData } from '@scouts/bookkeeping'

import { PLACE_OF_BUSINESS_BUSINESS } from '@/constants'
import { useUserAddresses } from '@/store/addresses/hooks'
import { useCompany } from '@/store/company'
import { useProfile } from '@/store/profile'
import { useSelfEmploymentProfile } from '@/store/self-employment-profile'

export const useBookkeepingUserData = (): ContextData => {
    const profile = useProfile()
    const addresses = useUserAddresses()
    const { company } = useCompany()
    const { selfEmploymentProfile } = useSelfEmploymentProfile()

    let address = addresses.businessAddress || addresses.address
    if (selfEmploymentProfile.placeOfBusiness !== PLACE_OF_BUSINESS_BUSINESS) {
        address = addresses.address || addresses.businessAddress
    }

    const user = {
        id: profile.id ?? 0,
        name: company?.name || `${profile.firstName || ''} ${profile.lastName || ''}`.trim(),
        idNumber: company?.uniqueTaxpayerReference || profile.uniqueTaxpayerReference || '',
        address: {
            street: company?.address?.streetAddress || address?.streetAddress || '',
            city: company?.address?.city || address?.city || '',
            postcode: company?.address?.postcode || address?.postcode || '',
        },
    }

    return { user }
}

export const useBookkeepingData = (): ContextData => {
    const { user } = useBookkeepingUserData()

    return { user }
}
